module.exports = __webpack_public_path__ + "static/media/s2.1f94758e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/s2.png
// module id = 12
// module chunks = 0